export const isSSR = (): boolean => typeof window === "undefined";
export const isProductionEnv: boolean =
  process.env.NEXT_PUBLIC_CONTEXT === "production";
export const isDev = process.env.NETLIFY_DEV === "true";
export const isPreviewBranch =
  process.env.NEXT_PUBLIC_CONTEXT &&
  process.env.NEXT_PUBLIC_CONTEXT !== "production";
export const getTopLevelDomain = () => {
  if (!window || !window.location) {
    return undefined;
  }

  const domainParts = window.location.hostname.split(".");
  const tld = domainParts.slice(domainParts.length - 2).join(".");

  return tld;
};
